import discardNullableValues from '@haaretz/s-common-utils/discardNullableValues';
import fetchUtility from '@haaretz/s-fetch-utility';
import mergeURLSearchParams from '@haaretz/s-navigation-utils/mergeURLSearchParams';
import { useSuspenseQuery } from '@tanstack/react-query';
export default function useClientSuspenseQuery({ url, variables, clientOptions, fetchOptions, searchParams, cacheKey }) {
    const isPostRequest = fetchOptions?.method === 'POST';
    const fetchSearchParam = mergeURLSearchParams(variables ? new URLSearchParams(discardNullableValues(variables)) : undefined, searchParams, {
        mergeMethod: 'set'
    });
    return useSuspenseQuery({
        queryKey: [
            'all',
            cacheKey,
            url,
            fetchSearchParam?.toString(),
            ...variables === undefined ? [] : [
                variables
            ]
        ].filter(Boolean),
        queryFn: async ({ signal })=>{
            return await fetchUtility({
                url,
                searchParams: fetchSearchParam,
                ...isPostRequest ? {
                    method: 'POST',
                    body: variables
                } : {
                    method: 'GET'
                },
                options: {
                    cache: 'no-cache'
                }
            })({
                signal
            });
        },
        ...clientOptions
    });
}

//# sourceMappingURL=useClientSuspenseQuery.js.map